import { render } from "./ConsignedSearch.vue?vue&type=template&id=67ae72e8"
import script from "./ConsignedSearch.vue?vue&type=script&lang=js"
export * from "./ConsignedSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__